import * as React from "react";

export class PlaceholderInfo extends React.PureComponent<{}, {}> {
    render() {
        return (
            <div className="rj-ev-list__placeholder__player-info">
                <div className="rj-ev-list__placeholder__player-names-wrap">
                    <div className="rj-ev-list__placeholder__player-name"></div>
                    <div className="rj-ev-list__placeholder__player-name"></div>
                </div>
                <div className="rj-ev-list__placeholder__card-item-icon"></div>
            </div>
        )
    }
}